import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useContext } from "react"
import {  useNavigate } from "react-router-dom"
import { LayoutContext } from "../../context"
import { Button } from "@nextui-org/react"

function SideNavItem({ navItem }) {
  const navigate=useNavigate()
  const { setShowSideNav } = useContext(LayoutContext)

  const handleSidenav = () => {
    navigate(navItem.url)
    setShowSideNav(false)
  }

  return (
    <li> 
      <Button
      size="sm"
        color="warning"
        variant="light"
        onClick={handleSidenav}
        startContent={<FontAwesomeIcon icon={navItem.icon} className="text-amber-600 text-xl " />}
        className="w-full flex justify-start text-xs font-semibold text-slate-900 uppercase bg-stone-50 "
      >
        {navItem.name}
      </Button>
    </li>
  )
}

export default SideNavItem
